module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('div', {
    staticClass: "content left"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_1block"
    }
  }, [_c('div', {
    staticClass: "response"
  }, [_c('div', {
    staticClass: "resendmail linkfont"
  }, [_c('span', {
    staticStyle: {
      "color": "#009A21"
    }
  }, [_vm._v("Link for password reset has been sent to "), _c('a', {
    attrs: {
      "href": "javascript: void(0)"
    }
  }, [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('p', [_vm._v("If you haven’t received the email , please click "), _c('a', {
    attrs: {
      "href": "javascript: void(0)"
    },
    on: {
      "click": function($event) {
        _vm.ResendMail()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to resend.")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button button-download",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("Back to Home")])])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cc130db!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/ResendMail.vue
// module id = 113
// module chunks = 1